var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',_vm._b({staticClass:"waiter-with-overlay",attrs:{"id":"Waiter","opacity":_vm.opacity,"z-index":100,"color":_vm.color}},'v-overlay',_vm.$attrs,false),[_c('v-progress-circular',{attrs:{"size":_vm.size,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }